import Vue from 'vue';
import SvgIcon from './index.vue';
// 注册svg图标
Vue.component('svg-icon', SvgIcon);

const req = require.context('./modules', false, /\.svg$/);

const requireAll = requireContext => requireContext.keys().map(requireContext);

requireAll(req);
